// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
const gmcSignOutButtonStyles = ({ iconFontFamily, palette }) => ({
  border: 0,
  padding: 0,
  fontSize: '14px',
  backgroundColor: 'white',
  color: '#0078d4',
  marginLeft: '10px',
});

// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
export const gmcSignInStatusSectionStyles = ({ iconFontFamily, palette }) => ({
  '& .gmc-signout-button': gmcSignOutButtonStyles({ iconFontFamily, palette }),
  '& .error': {
    color: '#a4262c',
    top: '10px',
    position: 'relative',
  },
});
